import * as React from 'react';

import { observer } from 'mobx-react';

import { ErrorBoundary } from '@estee/elc-telemetry';

import { TranslationRepository } from '~repositories/TranslationRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { useTranslation } from '~utils/hooks/translations';

import { CenterMessageView } from './common/CenterMessageView';
import { RampMainViewController } from './RampMainViewController';
import { RampRouter } from './RampRouter';

interface IRampMainProps {
    serviceViewName: string;
    isLoading?: boolean;
}

export const RampMain = observer(({ serviceViewName, isLoading }: IRampMainProps) => {
    const viewController: RampMainViewController = diContainer.get(
        serviceNames.rampMainViewController
    );
    const translationRepository: TranslationRepository = diContainer.get(
        serviceNames.translationRepository
    );
    translationRepository.loadTranslations(useTranslation());
    const { loadingLabel } = useTranslation();

    const [isLoadingState, setIsLoadingState] = React.useState(isLoading);

    const {
        data: { isConfigLoaded, isSetupReady, routerStore }
    } = viewController;

    React.useEffect(() => {
        setIsLoadingState(isLoading || !isConfigLoaded || !isSetupReady);
    }, [isLoading, isConfigLoaded, isSetupReady]);

    return (
        <ErrorBoundary name={serviceViewName} serviceName={__serviceInfo__.name}>
            {isLoadingState ? (
                <CenterMessageView>{loadingLabel}</CenterMessageView>
            ) : (
                <RampRouter routerStore={routerStore} />
            )}
        </ErrorBoundary>
    );
});
